export enum SimulationStatusEnum {
  NEW = "new",
  TEST = "test",
  INVESTIGATION = "investigation",
  ANONYMIZED = "anonymized",
}
